import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gift: null as any,
  donation_type_id: false as any,
  donation_type_name: "" as string,
  participants: [] as any,
  model_id: false as any,
  model: "" as string,
  mobile: "" as string,
  donner_name: "" as string,
  items: [] as any,
  beneficiary_lines: [] as any,
  type: "" as string,
  bookingLines: [] as any,
  donationLines: [] as any,
  sponsorship_booking_id: false as any,
  is_sponsorship_pay: false as boolean,
  program_application_id: false as any,
  month_number: false as any,
  renew_all: false as boolean,
};
export const moyasarSlice = createSlice({
  name: "moyasar",
  initialState: initialState,
  reducers: {
    setDonationTypeId: (state, action) => {
      state.donation_type_id = action.payload?.id;
      state.donation_type_name = action.payload?.name;
    },
    setModel: (state, action) => {
      state.model = action.payload;
    },
    setModelId: (state, action) => {
      state.model_id = action.payload;
    },
    setGift: (state, action) => {
      state.gift = action.payload;
    },
    setMobile: (state, action) => {
      state.mobile = action.payload;
    },
    setDonnerName: (state, action) => {
      state.donner_name = action.payload;
    },
    setItems: (state, action) => {
      state.items = action.payload;
      state.type = "payment_benefeciary";
      state.donation_type_name = "صدقة";
    },
    setBeneficiaryLines: (state, action) => {
      state.beneficiary_lines = action.payload;
      state.type = "beneficiary_lines";
    },
    setBookingLines: (state, action) => {
      state.bookingLines = action.payload;
      state.type = "booking_unsponsored";
    },
    setDonationLines: (state, action) => {
      state.donationLines = action.payload;
      state.type = "booking_sponsored";
    },
    setSponsorShipBookingId: (state, action) => {
      state.sponsorship_booking_id = action.payload;
      state.donation_type_name = "سداد كفالة";
    },
    setIsSponsorshipPay: (state, action) => {
      state.is_sponsorship_pay = action.payload;
      state.donation_type_name = "إضافة مبلغ في المحفظة";
    },
    setProgramId: (state, action) => {
      state.program_application_id = action.payload;
      state.donation_type_name = "الترشح على البرنامج";
      state.type = "program_pay";
    },
    setParticipants: (state, action) => {
      state.participants = action.payload;
      state.type = "participants";
      state.donation_type_name = "وقف النخيل";
    },
    setRenewSponsorShip: (state, action) => {
      state.month_number = action.payload;
      state.type = "sponsorship";
      state.donation_type_name = " تجديد كفالة";
    },
    setRenewAll: (state, action) => {
      state.renew_all = action.payload;
    },
    resetMoyasar: () => initialState,
  },

  extraReducers: (builder) => {},
});

export const {
  setDonationTypeId,
  setMobile,
  setDonnerName,
  setModel,
  setModelId,
  setGift,
  setItems,
  setBeneficiaryLines,
  setBookingLines,
  setDonationLines,
  setSponsorShipBookingId,
  setIsSponsorshipPay,
  setProgramId,
  setParticipants,
  setRenewSponsorShip,
  setRenewAll,
  resetMoyasar,
} = moyasarSlice.actions;

export default moyasarSlice.reducer;
